import type { ReactNode } from "react"

import ClarityController from "@/components/clarity-controller"
import AgencyWelcomeTourController from "@/components/demo-tour/agency-welcome-tour-controller"
import CheckoutTourController from "@/components/demo-tour/checkout-tour-controller"
import CustomerHubTourController from "@/components/demo-tour/customer-hub-tour-controller"
import DemoTourController from "@/components/demo-tour/demo-tour-controller"
import GleapController from "@/components/gleap-controller"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  return (
    <>
      <ClarityController />
      <GleapController />
      <DemoTourController />
      <CustomerHubTourController />
      <AgencyWelcomeTourController />
      <CheckoutTourController />
      {children}
      <Toaster richColors />
    </>
  )
}
